<template>
  <div class="container-fluid">
    <div class="flex-center-space-between">
      <div class="mr-1" style="width:50%">
        <div class="card">
          <div class="card-header">
            Nous contacter
          </div>
          <div class="card-container">
            <div class="card card-minimal table-scroll height-responsive-mercu">
              <h5 class="mb-2 mt-4"><a :href="'tel:'+ contactService.telephoneFixe"><i class="fas fa-phone-square mr-2 ml-2"></i>{{ contactService.telephoneFixeFormat }}</a></h5>
              <h5 class="mb-2"><a :href="'mailto:' + contactService.email"><i class="fas fa-envelope mr-2 ml-2"></i>{{ contactService.email }}</a></h5>
              <br/>
              <h5 class="m-2">Notre équipe :</h5>
              <template v-for="(contact, iContact) in listePersonne" >
                <span :key="'contact-'+iContact">
                  <h5 class="mt-2 mb-2"><a :href="'mailto:' + contact.email" ><i class="fas fa-user mr-2 ml-2"></i>{{ contact.prenomNom }} - {{ contact.email }}</a></h5>
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-1" style="width:50%">
        <div class="card">
          <div class="card-header">
            Informations
          </div>
          <div class="card-container">
            <div class="card card-minimal table-scroll height-responsive-mercu">
              <span class="flex-center-center mt-2"><h4>Bienvenue sur votre nouvel espace fournisseur Agap'Pro</h4></span>
              <span class="flex-center-center"><h5 class="mt-2">Ce site vous permet de gérer vos propositions de tarifs ainsi que l'ensemble de vos informations</h5></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import { connecteData } from "@/mixins/connecteData"
import { getContactsAgap } from '@/api/gpao/user'

export default {
  name: "Home",
  mixins: [connecteData],
  components: {},
  data() {
    return {
      informations: [],
      listeContacts: [],
      listePersonne: [],
      contactService: {}
    }
  },
  async mounted() {
    this.obtenirContacts()
  },
  methods: {
    ...mapActions("uxHelpers", ["cacherAttente"]),

    async obtenirContacts() {
      let response = await getContactsAgap()
      this.listeContacts = response.data
      this.contactService = this.listeContacts.filter(x => x.prenom === "Service").first()
      this.listePersonne = this.listeContacts.filter(x => x.prenom !== "Service") || []

    }

  }
}
</script>
